import { Popover } from "antd";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import axios from "axios";
import http from "@/utils/http";
import api from "@/utils/api";
import "./InsuranceVPH.scss";
import commonFn from "@/utils/commonFn";

const RemarkPopover = forwardRef(({ propRecord, v, children }, ref) => {
  const DescModalDoc = () => {
    const {
      vendorName,
      remark,
    } = propRecord;

    const IVPHMList = [
      { label: "Vendor Name", value: vendorName },
      { label: "Remark", value: remark },
    ];

    return (
      <div className="InsuranceVPHModal">
        {/* <div className="IVPHMtitle">{policyNumber}</div>
        <div className="IVPHMtime">
          {expirationDate + " - " + effectiveDate}
        </div> */}
        <div className="IVPHMListBox">
          {IVPHMList.map((item) => (
            <div className="IVPHMList">
              <div className="IVPHMName">{item.label}</div>
              <div className="IVPHMValue">{item.value}</div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <Popover
      content={DescModalDoc()}
      placement="left"
      // trigger="click"
    >
      {children}
    </Popover>
  );
});
export default RemarkPopover;
